<template>
    <div>
        <div style="z-index: 999; margin-top: 20px">
            <section>
                <div>
                    <div class="pull-right">
                        <label> Leadership level</label>
                        <select v-model="skill"  name="skill">
                            <option v-for="(label,index) in dropdownSkills" :value="index">
                                {{label}}
                            </option>
                        </select>
                        <button class="btn btn-link btn-xs" style="width: 20px;background: transparent;color: #1767a2"  type="button" @click="sendSkill()"><i class="fas fa-filter fa-2x" style="color: #1767a2 !important; "></i></button>
                    </div>
                </div>

            </section>
        </div>
    </div>
</template>
<script>

        export default {

            data () {
                return {
                    skill : null
                }
            },

            mounted () {
                console.log(app.__vue__.$refs);

                //this.setFilter = this.dropdownSet[0].id;
            // Overwriting base render method with actual data.
            },
        methods: {

            sendSkill(skills_id){

                console.log(skills_id,app.__vue__.$refs[this.refGraphWidget])

                // app.__vue__.$refs[this.refGraphWidget].getPeople(skills_id);
            }
        },
        props: {
          dropdownSkills: {
                type: Object,
                required: true,
            },

            refGraphWidget : {
                type: String,
                required: true
            },



        }

    }
</script>
